module.exports = __webpack_public_path__ + "static/media/taffiethule12.bf879a49.jpg";